import { tap } from 'lodash/fp';
import loaded from './loaded';
import globalError from './globalError';
import convertDesignToJob from '../api/mandi/convertDesignToJob';
import { INSTALLATION_PRICING } from './actionTypes';

export default (designId, leafItems, attributes = {}, mode = 'normal') => dispatch =>
  convertDesignToJob(designId, leafItems, attributes, { mode })
    .then(response => dispatch({
      type: INSTALLATION_PRICING,
      payload: {
        designId,
        pricingResult: response.pricingResult,
      },
    }))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
